module.exports = __webpack_public_path__ + "img/13m.8cbe1ba2.png";